<template>
  <order-form :mode="$route.query.mode || 'update'" :order-id="$route.query.id || ''" />
</template>

<script>
import OrderForm from "./components/order-form.vue";

export default {
  name: "workOrderEdit",
  components: { OrderForm },
};
</script>
